import React, { useContext } from 'react';
import { LanguageContext } from '../hooks/useLanguage';
import { Lang } from '../types';

const langs: Lang[] = ['es', 'en', 'fr'];

const LanguageSwitcher: React.FC = () => {
  const { lang, setLang } = useContext(LanguageContext);

  return (
    <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
      {langs.map((l, i) => (
        <React.Fragment key={l}>
          {i > 0 && (
            <span style={{ color: 'rgba(255,255,255,0.1)', fontSize: '10px' }}>|</span>
          )}
          <button
            onClick={() => setLang(l)}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontFamily: 'var(--font-body)',
              fontSize: '11px',
              fontWeight: 400,
              color: lang === l ? '#C8A96E' : '#555555',
              letterSpacing: '2px',
              padding: '4px 2px',
              transition: 'color 0.2s',
              textTransform: 'uppercase',
            }}
            onMouseEnter={(e) => { if (lang !== l) e.currentTarget.style.color = '#AAAAAA'; }}
            onMouseLeave={(e) => { if (lang !== l) e.currentTarget.style.color = '#555555'; }}
          >
            {l}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
